
import React, {Component} from 'react';
import {connect} from 'react-redux'
import { Pagination, DropdownButton, MenuItem, Form, FormGroup, Button } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import DatePicker from 'component/element/DatePicker'
import FontAwesome from 'react-fontawesome';
// import { Checkbox, Radio } from 'react-icheck';
// import './report.css';
import Moment from 'moment';
import ReportStore from 'stores/ReportStore';
import IframeModal from 'component/element/IframeModal'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import PrintButtons from 'component/element/PrintButtons'
const WHOLE_YEAR = momentHelper.getMonth()
class ReportAnalysisBestJobcardProduct extends Component {

  constructor(...args){
    super(...args)

    const optionsRows = [10,20,50,100,0];

    this.state = {
      data:[],
      loading:false,
      totalPage:0,
      activePage:1,
      defaultRows:20,
      optionsRows:optionsRows,
      dataExcel:[],
      year:momentHelper.getYear(),
      month:WHOLE_YEAR,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      isRange:false
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getAmountPerRow(item) {
    let quantity = (item.quantity===''||item.quantity===null||item.quantity===undefined||isNaN(item.quantity)?0:item.quantity)
    let price_per_unit = (item.price_per_unit===''||item.price_per_unit===null||item.price_per_unit===undefined||isNaN(item.price_per_unit)?0:item.price_per_unit)
    let sum = 0
    sum = (quantity*price_per_unit)
    return sum
  }

  getSummary() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let quantity = (item.quantity===''||item.quantity===null||item.quantity===undefined||isNaN(item.quantity)?0:item.quantity)
      let price_per_unit = (item.price_per_unit===''||item.price_per_unit===null||item.price_per_unit===undefined||isNaN(item.price_per_unit)?0:item.price_per_unit)
      sum += (quantity*price_per_unit)
    })
    return sum
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&this.props.show!==newProps.show) {
      this.loadData(this.state.year, this.state.month,this.state.day, 1, '', this.state.defaultRows)
    }
  }

  loadExcel(year='', month='', day='', complete) {
    let {isRange} = this.state
    if (isRange) {
      let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
      let end = this.state.dayRange+'/'+this.state.monthRange+'/'+(this.state.yearRange-543)
      ReportStore.loadReportAnalysisBestJobcardProductRange(start,end,0,'',(result)=>{
        this.setState({dataExcel:result.data},()=>{
          if (complete!==undefined)
            complete()
        })
      })  
    } else {
      ReportStore.loadReportAnalysisBestJobcardProduct(year, month, day, 0, '', (result)=>{
        this.setState({dataExcel:result.data},()=>{
          if (complete!==undefined)
            complete()
        })
      })
    }  
  }

  loadData(year='', month='', day='', page = 1, lengthData='', rowsData=20) {
    let that = this
    that.setState({loading:true,defaultRows:rowsData})
    let start = (page * rowsData) - rowsData
    if (page === 1) {
      start = 0
      that.setState({ activePage: page })
    }
    ReportStore.loadReportAnalysisBestJobcardProduct(year, month, day, start, (rowsData===0?'':rowsData), function(result) {
      let totalPage = result.data_count / rowsData
      if (rowsData===0)
        totalPage = 1
      that.setState({dataExcel:result.data,data:result.data,totalPage: Math.ceil(totalPage), loading:false})
    })  
  }

  loadDataRange(start='',end='',page = 1,rowsData=20) {
    ReportStore.loadReportAnalysisBestJobcardProductRange(start,end,page,(rowsData===0?'':rowsData),(result)=>{
      let totalPage = result.data_count / rowsData
      if (rowsData===0)
        totalPage = 1
      this.setState({dataExcel:result.data,data:result.data,totalPage: Math.ceil(totalPage), loading:false})
    })
  }

  handleSelect(e) {
    let {isRange} = this.state
    this.setState({ activePage: e })
    if (isRange) {
      let start = this.state.day+'/'+(this.state.month=='00'?'1':this.state.month)+'/'+(this.state.year-543)
      let end = this.state.dayRange+'/'+this.state.monthRange+'/'+(this.state.yearRange-543)
      this.loadDataRange(start,end,'',this.state.defaultRows)
    } else
      this.loadData(this.state.year, this.state.month, this.state.day, e, '', this.state.defaultRows)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day, activePage:1
    })  
    this.loadData(val.value, this.state.month, _day, 1, '', this.state.defaultRows)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day, activePage:1
    })
    this.loadData(this.state.year, val.value, _day, 1, '', this.state.defaultRows)
  }

  onDayChange(val) {
    this.setState({
      day: val.value, isRange:false, activePage:1
    })
    this.loadData(this.state.year, this.state.month, val.value, 1, '', this.state.defaultRows)
  }

  onRowsPerPageChange(e) {
    let {isRange} = this.state
    this.setState({ defaultRows: e })
    if (isRange) {
      let start = this.state.day+'/'+(this.state.month=='00'?'1':this.state.month)+'/'+(this.state.year-543)
      let end = this.state.dayRange+'/'+this.state.monthRange+'/'+(this.state.yearRange-543)
      this.loadDataRange(start,end,1,'',e)
    } else
      this.loadData(this.state.year,this.state.month,this.state.day,1,'',e)
  }

  onPrintTable(){
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportAnalysisBestJobcardProduct&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month==='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportAnalysisBestJobcardProduct&start_date='+start+'&end_date='+end+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div className="display-overflow">
        <table className="table table-responsive table-bordered-solid table-hover table-report-sale-product">
          <thead>
            <tr>
              <th style={{width:"50px"}} className="text-center">{messages['Code Part']}</th>
              <th style={{width:"130px"}}>{messages['Name Part']}</th>
              <th style={{width:"30px"}} className="text-center">{messages['Quantity']}</th>
              <th style={{width:"30px"}} className="text-center">{messages['Unit']}</th>
              <th style={{width:"50px"}} className="text-right">{messages['Value/Unit']}</th>
              <th style={{width:"50px"}} className="text-right">{messages['Total Value']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={4}></th>
              <th className="text-right"><b>{messages['Net Amount']}</b></th>
              <th className="text-right"><b>{this.getNumberFormat(this.getSummary())}</b></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }    

  renderRowData() {
    let {data} = this.state
    let {messages} = this.props

    if (data.length>0) {
      return(
        data.map((item, index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{item.productcode}</td>
              <td>{item.detail}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-center'>{item.unit}</td>
              <td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(this.getAmountPerRow(item))}</td>
            </tr>
          )  
        })
      )
    } else {
      return(<tr><td colSpan={6}>{messages['Data Not Found']}</td></tr>)
    }  
  }

  onExportExcel() {
    let {messages} = this.props
    this.loadExcel(this.state.year,this.state.month,this.state.day,()=>{
      const worksheet = XLSX.utils.table_to_book(document.getElementById('report-best-jobcard-product'));
      let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      }
      let fileName = messages['Report Name']+'-'+this.state.year+'-'+this.state.month+'-'+this.state.day+'.xlsx'
      FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
    })  
  }

  renderRowDataExcel() {
    let {messages} = this.props
    let {dataExcel} = this.state
    if (dataExcel.length===0) {
      return(<tr><td colSpan={6}>{messages['Data Not Found']}</td></tr>)
    } else {
      return(
        dataExcel.map((item,index)=> {
          return(
            <tr key={index}>
              <td className='text-center'>{item.productcode}</td>
              <td>{item.detail}</td>
              <td className='text-center'>{this.getNumberFormat(item.quantity)}</td>
              <td className='text-center'>{item.unit}</td>
              <td className='text-right'>{this.getNumberFormat(item.price_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(this.getAmountPerRow(item))}</td>
            </tr>
          )
        })
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00'||day===0) {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTableExcel() {
    let {messages} = this.props
    return(
      <div className="display-overflow" style={{display:'none'}}>
        <table id='report-best-jobcard-product' className="table table-responsive table-bordered-solid table-hover table-report-sale-product">
          <thead>
            <tr>
              <th className='text-center' colSpan={6}>{this.props.messages['Report Name']} {this.getDate()}</th>
            </tr>
            <tr>
              <th style={{width:"50px"}} className="text-center">{messages['Code Part']}</th>
              <th style={{width:"130px"}}>{messages['Name Part']}</th>
              <th style={{width:"30px"}} className="text-center">{messages['Quantity']}</th>
              <th style={{width:"30px"}} className="text-center">{messages['Unit']}</th>
              <th style={{width:"50px"}} className="text-right">{messages['Value/Unit']}</th>
              <th style={{width:"50px"}} className="text-right">{messages['Total Value']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowDataExcel()}
          </tbody>
        </table>
      </div>      
    )
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,'',this.state.defaultRows)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,'',this.state.defaultRows)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={false}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={false}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,1,'',this.state.defaultRows)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render(){

      let {messages} = this.props

      return (
        <div>  
          <Box loading={this.state.loading}>
            <Box.Header border={true}>
              {this.props.renderMenu()}
            </Box.Header>
            <Box.Body>
              {this.renderToolbar()}
              {this.renderDateRange()}
              {this.renderTable()}
              {this.renderTableExcel()}
                <div className="text-right">
                  <Form inline>
                    <FormGroup>
                      {messages['Number Of Rows Per Page']}
                    </FormGroup>  
                    {' '}
                    <FormGroup>
                      <DropdownButton id='' bsStyle={'default'} title={this.state.defaultRows===0?'ทั้งหมด':this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)}>
                        {this.state.optionsRows.map((item,index)=>(
                          <MenuItem key={index} eventKey={item}>{item===0?'ทั้งหมด':item}</MenuItem>  
                        ))}
                      </DropdownButton>
                    </FormGroup> 
                    {' '} 
                    <FormGroup style={{lineHeight:'10px'}}>
                      <Pagination
                        prev={messages['Previous']}
                        next={messages['Next']}
                        first={false}
                        last={false}
                        ellipsis
                        boundaryLinks
                        items={this.state.totalPage}
                        maxButtons={5}
                        activePage={this.state.activePage}
                        onSelect={this.handleSelect.bind(this)}
                      />
                    </FormGroup>  
                  </Form>  
                </div>  
              <IframeModal ref='iframe' title={messages['Print Document']} />
            </Box.Body>
          </Box>
        </div>
      ) 
  }
}


export default ReportAnalysisBestJobcardProduct = connect(
  (state) => ({messages: state.message.view.report.ReportAnalysisBestJobcardProduct}),null,null,{withRef:true}
)(ReportAnalysisBestJobcardProduct);





// WEBPACK FOOTER //
// ./src/view/report/statistics/ReportAnalysisBestJobcardProduct.js